import './intestazione.scss';

/**
 * version    1.0
 * class      <type> (Intestazione)
 * classdesc  Component that manage the intestazione section
 */
export class Intestazione {}
